export const matchCreditCardTypes = (cardType) => {
  const isVisa = /VS|VISA|VISA DEBIT|VISA CREDIT|VISA PREPAID/.test(
    cardType?.toUpperCase()
  )
  const isAmericanExpress = /AMEX|AMERICAN|EXPRESS|AX|AE|AMERICAN EXPRESS/.test(
    cardType?.toUpperCase()
  )
  const isDiscover = /DS|DISCOVER|NS|DC/.test(cardType?.toUpperCase())
  const isMasterCard = /MASTERCARD|MC|MASTERCARD DEBIT/.test(
    cardType?.toUpperCase()
  )

  return {
    isVisa,
    isAmericanExpress,
    isDiscover,
    isMasterCard,
  }
}
